var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToggleButton',{attrs:{"value":_vm.isEnabled,"sync":true,"labels":{ checked: 'On', unchecked: 'Off' }},on:{"change":function($event){return _vm.$emit('on-toggle', _vm.isEnabled)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }